module.exports = __webpack_public_path__ + "img/2.ff6d71cb.jpg";